// import { StoreDetailsCard } from '../storeDetailsCard';
import Typography from '../../../components/Typography/Typography';
import styles from './style.module.css';

interface IScrollableContainerProps {
  containername?: string;
  children?: React.ReactNode;
}

export const ScrollableContainer: React.FC<IScrollableContainerProps> = ({ containername = '', children }) => {
  return (
    <div className={styles.container}>
      <div><Typography className={styles.header}>{containername}</Typography></div>
      {/* <div className={styles.header}>{containername}</div> */}
      <div className={styles.contentContainer}>{children}</div>
    </div>
  );
};
